require.register("ffss/component/row/DocumentSearch", function(exports, require, module){
  $0
  
});

